import { useState } from "react";

import Overlay from "../../Componentes/Overlay";
import SidebarMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";

const RELATORIO_ENDPOINT = "/Painel/API/FolhaPag/GerarRelatorio/";

/* Tenta extrair uma mensagem JSON de um erro que voltou como blob
   (acontece quando a requisição é responseType: 'blob' e o servidor
   responde 4xx/5xx com JSON). */
const lerMensagemDeErroBlob = async (blob) => {
    try {
        const texto = await blob.text();
        const json = JSON.parse(texto);
        return json?.message ?? null;
    } catch {
        return null;
    }
};

const SidebarFolhaPag = ({ dados = [] }) => {

    const { closeModal, openModal } = useModal();
    const api = useApi();

    const [gerandoExcel, setGerandoExcel] = useState(false);

    const handleOpenNovoLancamento = () => {

        closeModal();
        openModal("modalNovoLancamento");

    }

    const handleGerarRelatorio = async () => {

        if (gerandoExcel) return;

        if (!Array.isArray(dados) || dados.length === 0) {
            alert("Não há lançamentos para exportar.");
            return;
        }

        setGerandoExcel(true);

        try {

            const response = await api.post(
                RELATORIO_ENDPOINT,
                { dados },
                { responseType: "blob" }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Folha_de_Pagamento.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            closeModal();

        } catch (error) {

            console.error("Erro ao gerar relatório:", error);

            let msg = "Erro ao gerar o relatório.";
            const data = error?.response?.data;
            if (data instanceof Blob) {
                const apiMsg = await lerMensagemDeErroBlob(data);
                if (apiMsg) msg = apiMsg;
            } else if (typeof data?.message === "string") {
                msg = data.message;
            }

            alert(msg);

        } finally {

            setGerandoExcel(false);

        }

    }

    return (
        <Overlay state={ true } changeContent={ closeModal } >
            <SidebarMenu>
                <SideMenuBtn
                    button="NOVO LANÇAMENTO"
                    clickFunc={ handleOpenNovoLancamento }
                />
                <SideMenuBtn
                    button="GERAR RELATÓRIO"
                    clickFunc={ handleGerarRelatorio }
                    isLoading={ gerandoExcel }
                />
            </SidebarMenu>
        </Overlay>
    )
}

export default SidebarFolhaPag;
